var _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterfootprints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13495_34351)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#08533F",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4066 24.8961C21.4905 25.0312 21.6676 25.0825 21.812 25.0032C21.8773 24.9613 21.9239 24.9007 21.9425 24.8215C21.9658 24.7469 21.9565 24.6677 21.9192 24.6025L21.7095 24.2483C21.6303 24.1132 21.4485 24.0572 21.3087 24.1411C21.1736 24.2204 21.1223 24.4021 21.2016 24.5326L21.4066 24.8961Z",
    fill: "#08533F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13495_34351",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 23,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H37.6667V41.1826H15V9Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13495_34351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0343 25.0633L26.756 9L17.4778 25.0633C15.5439 28.4139 15.5439 32.4169 17.4778 35.7722C19.4117 39.1228 22.8788 41.1266 26.756 41.1266C30.6239 41.1266 34.091 39.1228 36.0343 35.7722C37.9682 32.4169 37.9682 28.4139 36.0343 25.0633ZM25.2042 21.065C25.2042 20.3846 25.7588 19.8347 26.4345 19.8347C27.1149 19.8347 27.6647 20.3893 27.6647 21.065V21.5077C27.6647 22.1927 27.1102 22.7379 26.4345 22.7379C25.7495 22.7379 25.2042 22.1834 25.2042 21.5077V21.065ZM22.4128 21.3725C22.5806 21.0883 22.8416 20.8879 23.1631 20.7993C23.2703 20.7714 23.3775 20.7574 23.4846 20.7574C23.699 20.7574 23.9134 20.8133 24.0998 20.9252C24.384 21.0929 24.5891 21.3539 24.673 21.6754L24.7895 22.1042C24.9619 22.7612 24.5751 23.4416 23.918 23.6187C23.8109 23.642 23.7037 23.656 23.5965 23.656C23.3821 23.656 23.1678 23.6047 22.9814 23.4882C22.6924 23.3204 22.4921 23.0595 22.4035 22.7379L22.2917 22.3092C22.2031 21.9923 22.2451 21.6615 22.4128 21.3725ZM20.8657 23.3671C21.0521 23.2599 21.2525 23.2086 21.4529 23.2086C21.8629 23.2086 22.2637 23.423 22.4781 23.7958L22.6878 24.1593C22.8462 24.4342 22.8882 24.7464 22.8089 25.054C22.7251 25.3616 22.5247 25.6179 22.259 25.7763C22.0726 25.8835 21.8676 25.9394 21.6672 25.9394C21.2618 25.9394 20.861 25.7251 20.6467 25.3522L20.437 24.9934C20.1014 24.4202 20.2971 23.6886 20.8657 23.3671ZM26.756 40.162C23.2283 40.162 20.0781 38.3399 18.3166 35.2876C16.5551 32.2352 16.5551 28.5957 18.3166 25.5526C18.4378 25.3383 18.7127 25.2637 18.9271 25.3895C19.1368 25.5107 19.2113 25.7856 19.0855 26C17.4871 28.7681 17.4871 32.0768 19.0855 34.8495C20.6839 37.6176 23.5499 39.2766 26.7467 39.2766C26.9984 39.2766 27.1987 39.477 27.1987 39.7286C27.2034 39.9616 27.003 40.162 26.756 40.162ZM28.6713 30.3945C28.7039 30.4783 29.0768 31.3218 29.841 32.2352C29.8457 32.2445 29.8457 32.2445 29.855 32.2492C30.6099 33.2418 30.787 34.6258 30.2977 35.7862C29.8736 36.7834 29.0395 37.4312 27.9956 37.5663C27.9863 37.5663 27.9816 37.5663 27.9816 37.5663C27.8605 37.5757 27.744 37.5757 27.6368 37.5757C26.4764 37.5757 25.6329 37.0071 25.1203 35.8701C24.6823 34.8821 24.5611 33.582 24.4539 32.4449C24.3794 31.6527 24.3048 30.9071 24.1464 30.4084C23.9646 29.8632 23.7083 29.2434 23.3821 28.5677C23.3775 28.5491 23.3681 28.5351 23.3635 28.5164C22.4921 25.9115 24.0066 24.1965 25.563 23.5208C27.2127 22.8078 29.4915 23.0129 30.4701 24.807C31.1785 26.1212 29.841 27.9013 29.0395 28.6562C29.0302 28.6609 29.0255 28.6702 29.0162 28.6702C28.9929 28.7029 28.2799 29.332 28.6713 30.3945ZM31.281 21.2607C31.281 22.0995 30.5959 22.7799 29.7618 22.7799C28.923 22.7799 28.2426 22.0995 28.2426 21.2607V20.6595C28.2426 19.8207 28.923 19.1404 29.7618 19.1404C30.5959 19.1404 31.281 19.8207 31.281 20.6595V21.2607Z",
    fill: "#08533F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4274 28.0095C29.1916 27.2872 30.0538 25.9264 29.681 25.2461C28.954 23.9179 27.2018 23.7921 25.9109 24.356C24.6434 24.9012 23.5343 26.206 24.1914 28.2238C24.5269 28.9229 24.7925 29.5753 24.9789 30.1485C25.1747 30.7403 25.2492 31.5372 25.3284 32.3806C25.5754 35.0089 25.9063 36.8636 27.8775 36.6866C28.8561 36.5607 29.2895 35.8664 29.4666 35.4516C29.8254 34.5942 29.6903 33.5363 29.145 32.8047C28.255 31.7376 27.8495 30.7776 27.8309 30.7403C27.8309 30.731 27.8262 30.7263 27.8262 30.7263C27.2437 29.1186 28.2923 28.1306 28.4274 28.0095Z",
    fill: "#08533F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2622 22.5047C23.2855 22.5932 23.3414 22.6678 23.4253 22.7144C23.5045 22.761 23.5977 22.775 23.6862 22.747C23.8633 22.7004 23.9705 22.514 23.9239 22.323L23.812 21.8942C23.7701 21.7404 23.6303 21.6426 23.4858 21.6426C23.4579 21.6426 23.4253 21.6472 23.3973 21.6566C23.3088 21.6752 23.2342 21.7358 23.1876 21.815C23.141 21.8942 23.127 21.9921 23.155 22.076L23.2622 22.5047Z",
    fill: "#08533F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4339 21.8477C26.6203 21.8477 26.7741 21.6939 26.7741 21.5075V21.0648C26.7741 20.8784 26.6203 20.7246 26.4339 20.7246C26.2475 20.7246 26.0938 20.8784 26.0938 21.0648V21.5075C26.0938 21.6939 26.2475 21.8477 26.4339 21.8477Z",
    fill: "#08533F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7619 20.0293C29.4124 20.0293 29.1328 20.3089 29.1328 20.6584V21.2596C29.1328 21.6091 29.4124 21.8887 29.7619 21.8887C30.1068 21.8887 30.391 21.6091 30.391 21.2596V20.6584C30.391 20.3089 30.1068 20.0293 29.7619 20.0293Z",
    fill: "#08533F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13495_34351",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13495_34351"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13495_34351",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterfootprints);
export default __webpack_public_path__ + "static/media/waterfootprints.c8a40a8e975d6bdb1b6a4b42fbb1a700.svg";
export { ForwardRef as ReactComponent };